import { THUMBNAIL_HEIGHT } from '@app/core/thumbnails/consts';
import { StreamEl, theme } from '@mi-front/ui';
import { useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { getThreeTranscriptionWords } from '../utils';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
  ts: number;
}

export const DiarizarionFrame = styled.div<{ $isDark: boolean }>`
  border-radius: 6px;
  background-color: ${({ $isDark }: { $isDark: boolean }) =>
    $isDark ? '#0d2a33' : theme.aquaLight};
  border: 1px solid ${theme.aqua};
  color: ${({ $isDark }: { $isDark: boolean }) => ($isDark ? '#e2e8f0' : 'inherit')};
  width: 208px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
`;

export function StreamDiarization({ data, ts }: Props) {
  const words = useRef<string | null>('');
  const muiTheme = useTheme();
  const isDark = muiTheme.palette.mode === 'dark';

  useEffect(() => {
    words.current = getThreeTranscriptionWords(data, ts);
  }, [ts, data]);
  return words.current ? (
    <StreamEl
      ts={ts}
      checkOverflow
      offsetX={10}
      offsetY={THUMBNAIL_HEIGHT + 36}
      zIndex={100}
      position="center"
      noEvents
    >
      <DiarizarionFrame $isDark={isDark}>{words.current}</DiarizarionFrame>
    </StreamEl>
  ) : null;
}
